import React, { useEffect, useState } from 'react';
import makeAnimated from "react-select/animated";
import Select from "react-select";
import axios from "axios";
import apiUrl from "../../../shared/config";

const SingleAuthorInput = ({ authors_filter, userId, authorsUpdate, updatePage, closePatternDetails, placeholder, usersArr }) => {
    const [authors, setAuthors] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchAuthors = async () => {
            try {
                const response = await axios.get(apiUrl + 'Users/getUsers');
                setAuthors(response.data);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching authors:', error);
                setIsError(true);
                setIsLoading(false);
            }
        };

        // Fetch authors if not already loaded
        if (authors.length === 0 && !usersArr) {
            fetchAuthors();
        } else if (usersArr) {
            setAuthors(usersArr)
            setIsLoading(false);
        }

        // If no filter is set and userId is provided, update with the userId
        if (!authors_filter && userId > 0) {
            authorsUpdate(parseInt(userId));
        } else if (authors_filter) {
            authorsUpdate(parseInt(authors_filter));
        }
    }, [authors_filter, userId, authorsUpdate, authors.length, usersArr]);

    const handleChange = (selectedOption) => {
        const authorId = selectedOption ? selectedOption.value : null;
        console.log('Selected Author ID: ', authorId);
        authorsUpdate(authorId);
        updatePage(0);
        closePatternDetails(null);
    };

    if (isError) {
        return (
            <Select
                isSearchable
                isClearable
                options={[]}
                placeholder="Error loading authors. Please try again later."
            />
        );
    }

    if (isLoading) {
        return (
            <Select
                isSearchable
                isClearable
                options={[]}
                placeholder="Loading authors..."
            />
        );
    }

    if (authors.length > 0) {
        const authorOptions = [
            { value: null, label: '\u00A0\u00A0\u00A0\u00A0\u00A0', color: '#9999FF' },  // Blank option
            ...authors.map(author => ({
                value: author.user_id,
                label: author.display_name,
                color: '#9999FF'
            }))
        ];

        const animatedComponents = makeAnimated();

        const defaultOption = authors.find(author => author.user_id === authors_filter) || null;

        return (
            <span key={"Author Input"}>
                <Select
                    isSearchable
                    isClearable
                    options={authorOptions}
                    value={defaultOption ? { value: defaultOption.user_id, label: defaultOption.display_name, color: '#9999FF' } : null}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    placeholder={placeholder || "Select an author for this pattern."}
                    onChange={handleChange}
                />
            </span>
        );
    }

    return null;
};

export default SingleAuthorInput;